import { Modal } from '@mantine/core';
import useModal from 'src/new_arch/hooks/useModal';
import ShareViewOnlyLink from '../../components/ShareViewOnlyLink/ShareViewOnlyLink';

export type Shareable = {
	shareLink: ( { withDownloads } : { withDownloads: boolean } ) => string
}

type ShareViewOnlyLinkModalProps = {
	shareable: Shareable;
	onClose: () => void;
	stackOrder?: number;
}

const DEFAULT_STYLES = {
	overlay: { zIndex: 210 },
	inner: { zIndex: 211 },
	content: { backgroundColor: 'var(--color-bg-container)' },
	header: {
		padding: '10px 16px',
		borderBottom: '1px solid var(--color-outline-default)',
		backgroundColor: 'var(--color-bg-container)'
	},
	title: { color: 'var(--color-text-primary)' },
	close: { color: 'var(--color-text-primary)' },
	body: { padding: 0 }
};

const ShareViewOnlyLinkModal = ( { onClose, shareable, stackOrder = 1 }: ShareViewOnlyLinkModalProps ) => {
	const { opened, modalStyles } = useModal( {
		name: 'share-view-only-link',
		onClose,
		stackOrder,
		defaultStyles: DEFAULT_STYLES
	} );

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			title="View Only Link"
			className="ViewOnlyLinkModal"
			size={466}
			styles={modalStyles}
		>
			<ShareViewOnlyLink shareable={shareable} />
		</Modal>
	);
};

export default ShareViewOnlyLinkModal;
